<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useChatStore } from '../stores/chatStore';

const chatStore = useChatStore();
const { t } = useI18n();

const props = defineProps<{
    isShow: boolean;
    questions: string[];
    language: string;
}>();

const selectQuestion = (question: string) => {
    if (chatStore.isStreaming) {
        return;
    }

    const trimmed = question?.trim();
    if (!trimmed) {
        return;
    }

    chatStore.search(trimmed);
};
</script>

<template>
    <div v-if="props.isShow && props.questions.length > 0" class="mt-3">
        <div class="mb-2 text-sm font-semibold text-design-red"
            :class="chatStore.createLanguageClass(props.language)">
            {{ t('relatedQuestions') }}
        </div>
        <div class="flex flex-wrap gap-2">
            <button v-for="question in props.questions" :key="question" type="button"
                class="bg-white border border-solid border-design-red rounded-2xl px-3 py-1 text-sm hover:bg-design-pink disabled:opacity-60 disabled:cursor-not-allowed"
                @click="selectQuestion(question)" :disabled="chatStore.isStreaming"
                :class="chatStore.createLanguageClass(props.language)">
                {{ question }}
            </button>
        </div>
    </div>
</template>
